import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import translationEn from './locales/en.i18n.json';
import translationZhHans from './locales/zh_Hans.i18n.json';
import translationZhHant from './locales/zh_Hant.i18n.json';

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
    fallbackLng: 'en',
    debug: false,
    resources: {
        en: {translation: translationEn},
        zh_Hans: {translation: translationZhHans},
        zh_Hant: {translation: translationZhHant},
    },
    detection: {
        order: ['queryString', 'cookie'],
        cache: ['cookie']
    },
    interpolation: {
        escapeValue: false,
        prefix:"%",
        suffix:"$",
    }
})

export default i18n